import { msg } from "@lingui/core/macro";

export const expiresOnDayOfWeekRuleMessages = {
	name: msg({ message: "Expires On Day of Week" }),
	description: msg({ message: "Permit expiry date must fall on selected days of the week" }),
	errors: {
		noEndDate: msg({ message: "Permit must have an end date" }),
		invalidDay: msg({ message: "Permit must expire on one of the selected days: {dayOfWeek}" }),
	},
} as const;
